export default "__VITE_ASSET__U8Ar5uDa__"